import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  fetchProducts,

  selectCategory,
  deselectCategory,
  deselectAll,

  selectProducts,
  selectCategories,
  selectSelectedCategories
} from './store/products.slice'


const App = () => {

  const dispatch = useDispatch()
  const products = useSelector(selectProducts)
  const categories = useSelector(selectCategories)
  const selectedCategories = useSelector(selectSelectedCategories)

  const isSelected = category => selectedCategories.includes(category)

  useEffect(() => {
    dispatch(fetchProducts())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='py-8 bg-green-100 min-h-screen'>
      <div className='px-5 md:px-0 container mx-auto'>
        <div className='grid grid-cols-12 gap-5'>
          <div className=' col-span-12 flex justify-between'>
            <div className='uppercase tracking-wider text-gray-500'>
              categories
            </div>
            {selectedCategories.length === categories.length
              ? (
                <button className='text-xs text-black uppercase' onClick={() => dispatch(deselectAll())}>
                  Deselect All
                </button>
              ) : (
                <button className='text-xs text-black uppercase' onClick={() => dispatch(selectCategory(categories))}>
                  Select All
                </button>
              )
            }
          </div>
          {categories.map((category, categoryIndex) => (
            <button
              key={categoryIndex}
              onClick={() => dispatch(
                isSelected(category)
                  ? deselectCategory(category)
                  : selectCategory(category)
              )}
              className={`col-span-6 sm:col-span-4 md:col-span-3 lg:col-span-2 bg-white px-8 py-4 rounded shadow text-center${isSelected(category) ? ' bg-green-500 text-white font-semibold' : ''}`}
            >
              {category}
            </button>
          ))}
        </div>
        {selectedCategories.length ? (
          <div className='mt-8 grid grid-cols-12 gap-5'>
            <div className='uppercase col-span-12 tracking-wider text-gray-500'>products</div>
            {products.map(product => (
              <div key={product.key} className='col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 rounded bg-white p-4'>
                <div className='h-32 bg-gray-300 flex justify-center items-center uppercase rounded'>
                  THUMBNAIL
                </div>
                <div className='mt-4 text-center'>
                  <h4 className='font-bold text-lg'>{product.title}</h4>
                  <div className='text-2xl font-bold mt-2'>${product.price}</div>
                  <div className='text-xs text-white uppercase inline-block mt-3 '>
                    {product.stock <= 0
                      ? <div className='px-8 py-2 rounded-full bg-red-500'>Out of stock</div>
                      : product.stock <= 10
                        ? <div className='px-8 py-2 rounded-full bg-yellow-500'>Few left</div>
                        : <div className='px-8 py-2 rounded-full bg-green-500'>In stock</div>
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='mt-8 text-center text-2xl'>
            Please select at least one category
          </div>
        )}
      </div>
    </div>
  )
}

export default App;
